"use client"

import { useLanguage } from "@/contexts/language-context"

export function Stats() {
  const { t } = useLanguage()

  return (
    <section className="w-full py-12 md:py-24 bg-[#1a1310]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">{t("statsTitle")}</h2>
            <p className="max-w-[900px] text-muted-foreground md:text-xl">{t("statsDesc")}</p>
          </div>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-8 py-12 md:grid-cols-3">
          <div className="flex flex-col items-center justify-center space-y-2 text-center">
            <div className="text-4xl font-bold text-amber-500">{t("millionPlus")}</div>
            <p className="text-sm text-muted-foreground">{t("registeredUsers")}</p>
          </div>
          <div className="flex flex-col items-center justify-center space-y-2 text-center">
            <div className="text-4xl font-bold text-amber-500">{t("dailyCount")}</div>
            <p className="text-sm text-muted-foreground">{t("dailyImages")}</p>
          </div>
          <div className="flex flex-col items-center justify-center space-y-2 text-center">
            <div className="text-4xl font-bold text-amber-500">{t("rating")}</div>
            <p className="text-sm text-muted-foreground">{t("averageRating")}</p>
          </div>
        </div>
      </div>
    </section>
  )
}
